<template>
  <div>
    <Widget>
      <h3>Upcoming <span class="fw-semi-bold">Appointments</span></h3>
      <p>
        Table of upcoming appointments today
      </p>
      <div class="table-responsive">
        <table class="table table-lg mb-0 requests-table table-hover">
          <thead>
          <tr class="text-muted">
            <th width="20%"><span class="fw-bold">Date & Time</span></th>
            <th width="45%"><span class="fw-bold">Doctor</span></th>
            <th width="20%"><span class="fw-bold">Patient</span></th>
            <th width="20%"><span class="fw-bold">Amount</span></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="upcomingAppointment in upcomingAppointments" :key="upcomingAppointment.id">
            <td>{{ upcomingAppointment.start_time }}</td>
            <td>
                <span>
                  <b>{{upcomingAppointment.patientcheckup.doctor.name}}</b> ( {{ getdoctortype().find((dt) => dt.id === upcomingAppointment.patientcheckup.doctor.doctortype_id).name }} )
                  [ {{ upcomingAppointment.patientcheckup.doctor.user.mobile }} ]</span>
            </td>
            <td>
                <span><b>{{
                    upcomingAppointment.patientcheckup.patient.name
                  }}
                </b> [ {{ upcomingAppointment.patientcheckup.patient.user.mobile }} ]</span>
            </td>
            <td>{{ upcomingAppointment.patientcheckup.transaction.amount }}</td>
          </tr>
          </tbody>
        </table>

      </div>
      <b-pagination
          v-model="currentPage"
          :total-rows="tableRows"
          :per-page="perPage"
          first-number
          @input="fetchPendingAppointmentsToday"
      ></b-pagination>
    </Widget>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DoctorService from '@/services/admin/doctor.service';

export default {
  name: "Appointments",
  data() {
    return {
      currentPage: 1,
      tableRows: 100,
      perPage: 5,
      upcomingAppointments: [],
    };
  },
  computed: {
  },
  methods: {
    ...mapGetters('adminAuth', ['getdoctortype']),
    fetchPendingAppointmentsToday() {
      DoctorService.fetchPaginatedAppointmentsToday(this.currentPage)
          .then((response) => {
            if (response.status === 200) {
              this.perPage = response.data.per_page;
              this.tableRows = response.data.total;
              this.upcomingAppointments = response.data.data;
            }
          })
    }
  },
  mounted() {
    this.fetchPendingAppointmentsToday();
  }
}
</script>

<style scoped>

</style>
